// Generated by BUCKLESCRIPT VERSION 5.0.4, PLEASE EDIT WITH CARE
'use strict';

var Game = require("./game");
var Grid = require("./Grid");
var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Utils = require("./utils");
var React = require("react");
var Caml_obj = require("bs-platform/lib/js/caml_obj.js");
var SwipeZone = require("./SwipeZone");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");

var empty_grid = /* :: */[
  /* :: */[
    0,
    /* :: */[
      0,
      /* :: */[
        0,
        /* :: */[
          0,
          /* [] */0
        ]
      ]
    ]
  ],
  /* :: */[
    /* :: */[
      0,
      /* :: */[
        0,
        /* :: */[
          0,
          /* :: */[
            0,
            /* [] */0
          ]
        ]
      ]
    ],
    /* :: */[
      /* :: */[
        0,
        /* :: */[
          0,
          /* :: */[
            0,
            /* :: */[
              0,
              /* [] */0
            ]
          ]
        ]
      ],
      /* :: */[
        /* :: */[
          0,
          /* :: */[
            0,
            /* :: */[
              0,
              /* :: */[
                0,
                /* [] */0
              ]
            ]
          ]
        ],
        /* [] */0
      ]
    ]
  ]
];

var component = ReasonReact.reducerComponent("App");

function make(randomSeed, _children) {
  var on_keyup = function ($$event, self) {
    var match = $$event.key;
    switch (match) {
      case "ArrowDown" : 
          return Curry._1(self[/* send */3], /* Move */Block.__(0, [/* Down */3]));
      case "ArrowLeft" : 
          return Curry._1(self[/* send */3], /* Move */Block.__(0, [/* Left */0]));
      case "ArrowRight" : 
          return Curry._1(self[/* send */3], /* Move */Block.__(0, [/* Right */1]));
      case "ArrowUp" : 
          return Curry._1(self[/* send */3], /* Move */Block.__(0, [/* Up */2]));
      case "q" : 
          return Curry._1(self[/* send */3], /* Tick */0);
      default:
        return /* () */0;
    }
  };
  var on_toggle_autoplay = function (param, self) {
    var play = function (param) {
      self[/* state */1][/* animationFrameId */3][0] = Caml_option.some(requestAnimationFrame(play));
      return Curry._1(self[/* send */3], /* Tick */0);
    };
    var match = self[/* state */1][/* animationFrameId */3][0];
    if (match !== undefined) {
      return Curry._1(self[/* send */3], /* Stop */Block.__(1, [Caml_option.valFromOption(match)]));
    } else {
      play(0);
      return Curry._1(self[/* send */3], /* Start */1);
    }
  };
  var place_random_value = Game.fill_random_empty_tile(randomSeed);
  var maybe_place_value = function (grid) {
    var match = Curry._1(place_random_value, grid);
    if (match !== undefined) {
      return match;
    } else {
      return grid;
    }
  };
  var make_initial_state = function (param) {
    return /* record */[
            /* grid */maybe_place_value(maybe_place_value(empty_grid)),
            /* gameStatus : New */0,
            /* isPlaying */false,
            /* animationFrameId : record */[/* contents */undefined]
          ];
  };
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */(function (self) {
              var handler = Curry._1(self[/* handle */0], on_keyup);
              document.addEventListener("keyup", handler);
              return Curry._1(self[/* onUnmount */4], (function (param) {
                            document.removeEventListener("keyup", handler);
                            return /* () */0;
                          }));
            }),
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function (self) {
              var match = process.env.NODE_ENV;
              var tmp;
              if (match === "development") {
                var match$1 = self[/* state */1][/* isPlaying */2];
                tmp = React.createElement("button", {
                      className: "new-game",
                      onClick: Curry._1(self[/* handle */0], on_toggle_autoplay)
                    }, Utils.render_string(match$1 ? "Stop" : "Auto"));
              } else {
                tmp = React.createElement("span", undefined);
              }
              return React.createElement("div", undefined, React.createElement("header", undefined, React.createElement("h1", {
                                  className: "heading"
                                }, Utils.render_string("2048 "), React.createElement("span", {
                                      className: "reason"
                                    }, React.createElement("span", {
                                          className: "re"
                                        }, Utils.render_string("RE")), Utils.render_string("ASONS")))), React.createElement("div", {
                              className: "controls"
                            }, tmp, React.createElement("button", {
                                  className: "new-game",
                                  onClick: (function (param) {
                                      return Curry._1(self[/* send */3], /* Reset */2);
                                    }),
                                  onTouchEnd: (function (param) {
                                      return Curry._1(self[/* send */3], /* Reset */2);
                                    })
                                }, Utils.render_string("New Game"))), ReasonReact.element(undefined, undefined, SwipeZone.make((function (direction) {
                                    return Curry._1(self[/* send */3], /* Move */Block.__(0, [direction]));
                                  }), /* array */[ReasonReact.element(undefined, undefined, Grid.make(self[/* state */1][/* grid */0], self[/* state */1][/* gameStatus */1], /* array */[]))])), React.createElement("section", {
                              className: "hint"
                            }, Utils.render_string("use ←, ↑, → and ↓ to play")));
            }),
          /* initialState */(function (param) {
              return make_initial_state(/* () */0);
            }),
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */(function (action, state) {
              if (typeof action === "number") {
                switch (action) {
                  case 0 : 
                      var direction = Game.best_move(state[/* grid */0]);
                      if (direction !== undefined) {
                        var direction$prime = direction;
                        return /* SideEffects */Block.__(1, [(function (self) {
                                      return Curry._1(self[/* send */3], /* Move */Block.__(0, [direction$prime]));
                                    })]);
                      } else {
                        var match = state[/* animationFrameId */3][0];
                        if (match !== undefined) {
                          cancelAnimationFrame(Caml_option.valFromOption(match));
                          return /* Update */Block.__(0, [/* record */[
                                      /* grid */state[/* grid */0],
                                      /* gameStatus : Lost */3,
                                      /* isPlaying */false,
                                      /* animationFrameId */state[/* animationFrameId */3]
                                    ]]);
                        } else {
                          return /* Update */Block.__(0, [/* record */[
                                      /* grid */state[/* grid */0],
                                      /* gameStatus : Lost */3,
                                      /* isPlaying */false,
                                      /* animationFrameId */state[/* animationFrameId */3]
                                    ]]);
                        }
                      }
                  case 1 : 
                      return /* Update */Block.__(0, [/* record */[
                                  /* grid */state[/* grid */0],
                                  /* gameStatus */state[/* gameStatus */1],
                                  /* isPlaying */true,
                                  /* animationFrameId */state[/* animationFrameId */3]
                                ]]);
                  case 2 : 
                      return /* Update */Block.__(0, [make_initial_state(/* () */0)]);
                  
                }
              } else if (action.tag) {
                cancelAnimationFrame(action[0]);
                return /* Update */Block.__(0, [/* record */[
                            /* grid */state[/* grid */0],
                            /* gameStatus */state[/* gameStatus */1],
                            /* isPlaying */false,
                            /* animationFrameId : record */[/* contents */undefined]
                          ]]);
              } else {
                var new_grid = Game.merge(action[0])(state[/* grid */0]);
                if (Caml_obj.caml_equal(new_grid, state[/* grid */0])) {
                  var match$1 = Game.is_mergeable(new_grid);
                  if (match$1) {
                    return /* NoUpdate */0;
                  } else {
                    return /* Update */Block.__(0, [/* record */[
                                /* grid */state[/* grid */0],
                                /* gameStatus : Lost */3,
                                /* isPlaying */state[/* isPlaying */2],
                                /* animationFrameId */state[/* animationFrameId */3]
                              ]]);
                  }
                } else {
                  var match$2 = Curry._1(place_random_value, new_grid);
                  if (match$2 !== undefined) {
                    return /* Update */Block.__(0, [/* record */[
                                /* grid */match$2,
                                /* gameStatus */state[/* gameStatus */1],
                                /* isPlaying */state[/* isPlaying */2],
                                /* animationFrameId */state[/* animationFrameId */3]
                              ]]);
                  } else {
                    return /* Update */Block.__(0, [/* record */[
                                /* grid */state[/* grid */0],
                                /* gameStatus : Lost */3,
                                /* isPlaying */state[/* isPlaying */2],
                                /* animationFrameId */state[/* animationFrameId */3]
                              ]]);
                  }
                }
              }
            }),
          /* jsElementWrapped */component[/* jsElementWrapped */13]
        ];
}

exports.empty_grid = empty_grid;
exports.component = component;
exports.make = make;
/* component Not a pure module */
